import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChatHoursModalWindowComponent } from 'src/app/shared/components/chat-hours-modal-window/chat-hours-modal-window.component';
import { DeviceSelectionDialogComponent } from 'src/app/shared/components/device-selection-dialog/device-selection-dialog.component';
import { ADPResourceService } from 'digital-core';
import { UtilityService } from '../services/utility.service';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { AsappChatService } from '../services/asapp-chat.service';

@Injectable({
  providedIn: 'root',
})
export class ChatHandler {
  public isNative: boolean;
  public chatOffHoursStartTimeInUTC = '4';
  public chatOffHoursEndTimeInUTC = '12';

  constructor(
    private matDialog: MatDialog,
    public resourceService: ADPResourceService,
    public utilityService: UtilityService,
    private activatedRoute: ActivatedRoute,
    private asappChatService: AsappChatService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.isNative = (params.isNative && params.isNative.toLowerCase().trim() === 'true') || this.utilityService.isNativeApp;
    });
  }

  public openDeviceSelectionDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'device-selection-dialog';

    const dialogRef = this.matDialog.open(DeviceSelectionDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'phone') {
        // Open Asapp chat
        this.openAsappChat();
      } else if (result === 'home') {
        // Trigger checkChatHours function
        this.openTechSupportChat();
      }
    });
  }

  public openTechSupportChat() {
    // Don't attempt to launch chat in native mobile app
    if (this.isNative) {
      return;
    }

    const button: HTMLElement = document.querySelector('.helpButtonEnabled');
    if (button) {
      button.click();
    } else {
      this.openUnavailableDialog();
    }
  }

  openChatInterface(hasMobilePolicy = false, hasHomeTechPolicy = true) {
    // Don't attempt to launch chat in native mobile app
    if (this.isNative) {
      return;
    }

    // User has both mobile and home tech policies
    if (hasMobilePolicy && hasHomeTechPolicy) {
      this.openDeviceSelectionDialog();
      return;
    }

    // User has only mobile policy
    if (hasMobilePolicy) {
      this.openAsappChat();
      return;
    }

    // User has only home tech policy
    if (hasHomeTechPolicy) {
      this.openTechSupportChat();
      return;
    }

    // If no policies are selected, no action required
  }

  openAsappChat() {
    // Don't attempt to launch chat in native mobile app
    if (this.isNative) {
      return;
    }
    if (this.asappChatService.isInitialized) {
      this.asappChatService.show();
    } else {
      this.openUnavailableDialog();
    }
  }

  openUnavailableDialog() {
    this.chatOffHoursStartTimeInUTC = this.resourceService.getPortalSetting('Chat_OffHours_StartTime_UTC24HT')?.Value ?? '4';
    this.chatOffHoursEndTimeInUTC = this.resourceService.getPortalSetting('Chat_OffHours_EndTime_UTC24HT')?.Value ?? '12';

    const dialogConfig = new MatDialogConfig();
    const now = new Date();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'chat-hours-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data =
      now.getUTCHours() >= parseInt(this.chatOffHoursStartTimeInUTC) && now.getUTCHours() < parseInt(this.chatOffHoursEndTimeInUTC)
        ? {
          title: 'Chat_Unavailable_Modal_Title',
          content: 'Chat_Unavailable_Modal_Content',
          buttonText: 'Global_Button_Close',
        }
        : {
          title: 'Chat_NoAgents_Modal_Title',
          content: 'Chat_NoAgents_Modal_Content',
          buttonText: 'Global_Button_Close',
        };

    this.matDialog.open(ChatHoursModalWindowComponent, dialogConfig);
  }
}
